/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Purchase_Fail_TitleInputs */

const en_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchased failed`)
};

const ar_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشلت عملية الشراء`)
};

const de_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kauf fehlgeschlagen`)
};

const es_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compra ha fallado`)
};

const fr_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'achat`)
};

const it_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisto non riuscito`)
};

const ja_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入に失敗しました`)
};

const ko_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매 실패`)
};

const pt_br_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na compra`)
};

const ru_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось совершить покупку`)
};

const th_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การซื้อล้มเหลว`)
};

const tr_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satın alma işlemi başarısız`)
};

const zh_cn_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买失败`)
};

const zh_tw_dialog_purchase_fail_title = /** @type {(inputs: Dialog_Purchase_Fail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購買失敗`)
};

/**
* | output |
* | --- |
* | "Purchased failed" |
*
* @param {Dialog_Purchase_Fail_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_purchase_fail_title = /** @type {((inputs?: Dialog_Purchase_Fail_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Purchase_Fail_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_purchase_fail_title(inputs)
	if (locale === "ar") return ar_dialog_purchase_fail_title(inputs)
	if (locale === "de") return de_dialog_purchase_fail_title(inputs)
	if (locale === "es") return es_dialog_purchase_fail_title(inputs)
	if (locale === "fr") return fr_dialog_purchase_fail_title(inputs)
	if (locale === "it") return it_dialog_purchase_fail_title(inputs)
	if (locale === "ja") return ja_dialog_purchase_fail_title(inputs)
	if (locale === "ko") return ko_dialog_purchase_fail_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_purchase_fail_title(inputs)
	if (locale === "ru") return ru_dialog_purchase_fail_title(inputs)
	if (locale === "th") return th_dialog_purchase_fail_title(inputs)
	if (locale === "tr") return tr_dialog_purchase_fail_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_purchase_fail_title(inputs)
	return zh_tw_dialog_purchase_fail_title(inputs)
});